import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedMovies from './components/FeaturedMovies';
import TrendingList from './components/TrendingList';
import LatestArticles from './components/LatestArticles';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '窝窝影院 - 高清播放在线不缓冲，流畅观看超清画质无广告',
  description: '窝窝影院提供高清播放、在线不缓冲的流畅观影体验，超清画质无广告，海量电影电视剧免费在线观看，每日更新不卡顿。',
  url: 'https://wowocinema.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '窝窝影院',
    url: 'https://wowocinema.com',
  },
  mainEntity: {
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'Movie',
        name: '流浪地球3',
        description: '太阳急速老化，人类面临末日危机。各国联合启动流浪地球计划。',
      },
      {
        '@type': 'Movie',
        name: '长津湖之水门桥',
        description: '1950年寒冬，志愿军战士们在水门桥展开殊死战斗。',
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(homepageSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedMovies />
          <TrendingList />
          <LatestArticles />
        </main>
        <Footer />
      </div>
    </>
  );
}